import type { YourEvent } from '../data/types'
import { truthy } from '../data/types'
import { formatEventDateRange } from '../data/format'
import styles from './HeroCards.module.css'

/** The racer's own soonest upcoming entered event, pinned above Featured/RaceTime (decision:
 *  single soonest only). Same dark "Your events" row on mobile (Main.dc.html) and desktop
 *  (Desktop.dc.html) - only spacing differs, handled in CSS. */
export function YourEventCard({ event }: { event: YourEvent }) {
  const href = `/events/displayEvent.cfm?ID=${event.id}`
  const paidLabel = truthy(event.enteredPaid) ? ' · paid' : ''

  return (
    <a href={href} className={styles.yourEvent}>
      {event.flyerUrl ? <img src={event.flyerUrl} alt="" className={styles.yourEventThumb} /> : null}
      <span className={styles.yourEventLabel}>Your events</span>
      <span className={styles.yourEventBody}>
        <span className={styles.yourEventTitle}>{event.name}</span>
        <span className={styles.yourEventMeta}>
          {formatEventDateRange(event.startDT, event.endDT)} · {event.city}, {event.state}
        </span>
      </span>
      <span className={styles.yourEventMeta}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#3ccf72" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M5 12l5 5L20 7" />
        </svg>
        Entered · {event.enteredClassCount} class{event.enteredClassCount === 1 ? '' : 'es'}
        {paidLabel}
      </span>
      <span className={styles.yourEventCta}>View entry</span>
    </a>
  )
}
